import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_jumping.svg?webp'
import _imports_1 from '@/assets/img/caikuma_confused.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-db15707c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined circle" }, "\n            circle\n          ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined cross" }, "\n            close\n          ", -1))
const _hoisted_4 = { class: "message" }
const _hoisted_5 = { class: "mascot-container" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "正解",
  class: "mascot-image"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "不正解",
  class: "mascot-image"
}

import { ref } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NextModal',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const isCorrect = ref(false);
const promiseResolver = ref<(() => void) | null>(null);

const show = (isValid: boolean) => {
  visible.value = true;
  return new Promise<void>(resolve => {
    promiseResolver.value = resolve;
    isCorrect.value = isValid;
  });
};

const onClose = () => {
  visible.value = false;
  if (promiseResolver.value) {
    promiseResolver.value();
    promiseResolver.value = null;
  }
};

__expose({
  show
});

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: visible.value,
    "hide-header": "",
    "hide-footer": "",
    centered: "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    onHide: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["result-title", { correct: isCorrect.value, incorrect: !isCorrect.value }])
        }, [
          (isCorrect.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_2,
                _createTextVNode("\n          正解\n        ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_3,
                _createTextVNode("\n          不正解\n        ")
              ], 64))
        ], 2),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_4, _toDisplayString(isCorrect.value ? "おめでとうございます！" : "もう一回答えてください"), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_5, [
          (isCorrect.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (_openBlock(), _createElementBlock("img", _hoisted_7))
        ]),
        _createTextVNode(),
        _createVNode(AppButton, {
          block: "",
          onClick: onClose,
          class: "ok-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        OK\n      ")
          ], undefined, true),
          _: 1
        })
      ])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})